import api from './api';

export const authService = {
  /**
   * Admin/Staff Login
   * @param {string} email - Email address
   * @param {string} password - Password
   * @returns {Promise} Login response with token
   */
  
  login: async (email, password) => {
    try {
      const response = await api.post('/auth/login', {
        email,
        password,
      });
      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('user', JSON.stringify(response.data.user));
      }
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Login failed' };
    }
  },

  /**
   * Parent Login with Mobile & PIN
   * Specific to FeeZaap parent portal
   * @param {string} mobile - Parent mobile number
   * @param {string} pin - 4-digit PIN
   * @returns {Promise} Login response with token
   */
  parentLogin: async (mobile, pin) => {
    try {
      const response = await api.post('/auth/parent-login', {
        mobile,
        pin,
      });
      if (response.data.token) {
        localStorage.setItem('authToken', response.data.token);
        localStorage.setItem('parentInfo', JSON.stringify(response.data.parent));
      }
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Parent login failed' };
    }
  },

  /**
   * Register new admin/staff
   * @param {object} userData - User registration data
   * @returns {Promise} Registration response
   */
  register: async (userData) => {
    try {
      const response = await api.post('/auth/register', userData);
      return response.data;
    } catch (error) {
      throw error.response?.data || { message: 'Registration failed' };
    }
  },

  /**
   * Logout - Clear tokens
   */
  logout: () => {
    localStorage.removeItem('authToken');
    localStorage.removeItem('user');
    localStorage.removeItem('parentInfo');
  },

  /**
   * Get current user info
   * @returns {object} User data from localStorage
   */
  getCurrentUser: () => {
    const user = localStorage.getItem('user');
    return user ? JSON.parse(user) : null;
  },

  /**
   * Check if user is authenticated
   * @returns {boolean}
   */
  isAuthenticated: () => {
    return !!localStorage.getItem('authToken');
  },

  /**
   * Get current auth token
   * @returns {string|null}
   */
  getToken: () => {
    return localStorage.getItem('authToken');
  },
};

export default authService;
